// extracted by mini-css-extract-plugin
export var closeButton = "_kj-1";
export var closeX = "_kj-3";
export var container = "_kj-0";
export var image = "_kj-2";